// extracted by mini-css-extract-plugin
export default {"checkboxes":"MezzaMessageSetup_checkboxes__TiLg9","opener":"MezzaMessageSetup_opener__YtlLO","warning":"MezzaMessageSetup_warning__mxxUr"};